const money0 = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 });

export const euro = (n: number): string => `${money0.format(Math.round(n))} €`;
export const int = (n: number): string => money0.format(Math.round(n));
export const rate = (n: number): string => `${n.toFixed(2)}/s`;
export const pct = (n: number): string => `${Math.round(n * 100)} %`;

/**
 * True when the primary pointer cannot hover — a finger, not a mouse. Read per
 * call rather than cached: plugging in a mouse or crossing the breakpoint has to
 * change the answer, and every caller already rewrites its string anyway.
 */
export const coarsePointer = (): boolean => matchMedia("(pointer: coarse)").matches;

/** Element holen oder laut scheitern — spart überall `!`. */
export function need<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Element #${id} fehlt im HTML`);
  return el as T;
}
